import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import { OrganizationInfoResponse } from "./types";

export const OrganizationInfoAPI = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: "OrganizationInfoApi",
	endpoints: (builder) => ({
		getOrganizationInfo: builder.query<OrganizationInfoResponse, void>({
			query: () => ({
				url: `/v2/content/organizations/tree`,
				method: "GET",
			}),
			transformResponse: (response: OrganizationInfoResponse) => ({
				isErr: undefined,
				data: response.data,
			}),
		}),
	}),
});

export const { useGetOrganizationInfoQuery } = OrganizationInfoAPI;
